const getPrimaryColor = (appColor?: string) => (appColor as any) || 'blue'; // tslint:disable-line
const getSecondaryColor = () => 'grey' as 'grey';
const getErrorColor = (appColor?: string) => (appColor === 'red' ? 'deepOrange' : 'red');

export { getPrimaryColor, getSecondaryColor, getErrorColor };
